import React, { useContext, useState } from 'react'
import Layout from '../../../shared/components/organisms/layout/layout'
import { Context } from '../../../context/app-context'
import ModalViewer from '../../organisms/modal-viewer/modal-viewer'
import NavMenu, { NavMenuOptions } from '../../molecules/nav-menu/nav-menu'
import AppSEO from '../../atoms/app-seo/app-seo'
import useMediaQuery from '../../../utils/useMediaQuery'
import './page-layout.scss'
import CrazyEgg from '../../../utils/CrazyEgg'

const PageLayout = ({
  children,
  hiddenNav,
  className,
}: {
  children: React.ReactNode
  hiddenNav?: boolean
  className?: string
}) => {
  const isMobile = useMediaQuery()
  const [activeMenu, setActiveMenu] = useState(false)
  const toggleButton = () => {
    setActiveMenu(prevState => !prevState)
  }
  const { dispatch } = useContext(Context)

  const handleTerms = async () => {
    dispatch!({
      type: 'set-modal',
      modalActive: {
        type: 'terms',
        wrapperProps: {
          className: 'f-modalTerms',
        },
        props: {
          close: () => {
            dispatch!({ type: 'clear-modal' })
          },
        },
      },
    })
  }

  return (
    <>
      <Layout mobile={isMobile}>
        <CrazyEgg />
        <AppSEO />
        <ModalViewer />
        <div
          className={
            'f-page-layout__container' + (className ? ' ' + className : '')
          }
        >
          {!hiddenNav && (
            <NavMenu isMobile={isMobile} toggleButton={toggleButton} />
          )}
          <div>{children}</div>
        </div>
        <div className="f-containerTerminos">
          <p>
            Conoce los{' '}
            <a className="f-containerTerminos__link" onClick={handleTerms}>
              términos y condiciones
            </a>
          </p>
        </div>
      </Layout>
      {isMobile && (
        <div
          className={`f-navMenu-mobile-container ${activeMenu ? 'showMenu' : 'hideMenu'}`}
        >
          <button className="f-navMenu-mobile-close_btn" onClick={toggleButton}>
            <span></span>
            <span></span>
          </button>
          <NavMenuOptions toggleButton={toggleButton} />
        </div>
      )}
    </>
  )
}

export default PageLayout
